export const editMutations = <const>{
	CIZY_VYKONY_CV_SELECT_MAPPER: 'CIZY_VYKONY_CV_SELECT_MAPPER',
	CIZY_VYKONY_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'CIZY_VYKONY_NAKLADOVE_STREDISKO_SELECT_MAPPER',
};
